import { DemGtnSummary } from '@/gtn/org/dem/gtnSummary/DemGtnSummary';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useMemo } from 'react';

export const DemActualsGtnDashboard = () => {
  const reqParam = useMemo(() => ({}), []);

  return (
    <DemGtnSummary
      dataPlugin="ACTUALS_GTN_DATA_PLUGIN"
      filtersPlugin="ACTUALS_GTN_FILTERS_DATA_PLUGIN"
      reqParam={reqParam}
      title="Gross-to-Net Summary"
      titleIcon={fas.faFilterCircleDollar}
    />
  );
};
